import { createStore, createHook, type Action } from 'react-sweet-state';
import type { State } from './types';

const actions = {
	setIsSelected:
		(isSelected: boolean): Action<State> =>
		({ setState }) => {
			setState({ isSelected });
		},
	setCreateIndex:
		(columnIndex?: number | undefined): Action<State> =>
		({ setState }) => {
			setState({
				createIndex: columnIndex !== undefined ? columnIndex + 1 : undefined,
			});
		},
	clearCreateIndex:
		(): Action<State> =>
		({ setState }) => {
			setState({ createIndex: undefined });
		},
	addCreateField:
		({ fieldId, name, type }: { fieldId: string; name: string; type: string }): Action<State> =>
		({ setState, getState }) => {
			setState({
				createFields: [
					...getState().createFields,
					{ fieldId, name, type, createIndex: getState().createIndex },
				],
			});
		},
	removeCreateField:
		(fieldId: string): Action<State> =>
		({ setState, getState }) => {
			setState({
				createFields: [...getState().createFields.filter((field) => field.fieldId !== fieldId)],
			});
		},
};

type Actions = typeof actions;

const Store = createStore<State, Actions>({
	initialState: {
		isSelected: false,
		createIndex: undefined,
		createFields: [],
	},
	actions,
	name: 'JwmListInlineFieldCreate',
});

export const useInlineFieldCreateControls = createHook<State, Actions>(Store);
